import { Skeleton } from "@/components/atoms";
import { usePricingProfileContext, useZoneRatesContext, ZoneRatesPanel } from "@/components/organisms";
import { Restricted } from "@/components/pages/Restricted/Restricted";
import { ZoneRatesAdd } from "./ZoneRatesAdd";
import { ZoneRatesEdit } from "./ZoneRatesEdit";

export const ZoneRates = () => {
  const { isFetching: isFetchingPricingProfile, isRestricted } = usePricingProfileContext();
  const { isFetching: isFetchingZoneRates } = useZoneRatesContext();
  const isFetching = isFetchingPricingProfile || isFetchingZoneRates;

  if (isFetching) {
    return (
      <div className="flex min-h-[calc(100vh-120px)] flex-1 flex-col px-5 py-4">
        <Skeleton />
      </div>
    );
  }

  return (
    <div className="flex min-h-[calc(100vh-120px)] flex-1 flex-col px-5 py-4">{isRestricted ? <Restricted /> : <ZoneRatesPanel />}</div>
  );
};

ZoneRates.Add = ZoneRatesAdd;
ZoneRates.Edit = ZoneRatesEdit;
